import { Navigate, Route, useParams } from "react-router-dom";


// The old /profile pages are retired: every one of them now lives in the System module. Each old
// address (bookmarks, links still pointing here) is sent to the page that replaced it.
const NEW_PAGES: { [oldPath: string]: string } = {
  "": "/system/account/overview",
  "overview": "/system/account/overview",
  "edit": "/system/account/edit-account",
  "account": "/system/account/edit-account",
  "account/password": "/system/account/security",
  "preferences/account": "/system/account/edit-account",
  "company": "/system/account/company",
  "security": "/system/account/security",
  "preferences": "/system/account/preferences",
  "notifications": "/system/account/notification-history",
  "subscription": "/system/finance/subscription",
  "billing/subscription": "/system/finance/subscription",
  "payment-methods": "/system/finance/payment-methods",
  "wallet": "/system/finance/wallet",
  "invoices": "/system/finance/invoices",
};

function ProfileRedirect() {
  const { selectedPage, selectedAction } = useParams();
  const page = (selectedPage ?? "").toLowerCase();
  const path = selectedAction ? `${page}/${selectedAction.toLowerCase()}` : page;
  return <Navigate to={NEW_PAGES[path] ?? NEW_PAGES[page] ?? "/system"} replace />;
}

function ProfileRoutes() {
  return (
    [
      <Route key={0} path="/profile" element={<ProfileRedirect />} />,
      <Route key={1} path="/profile/:selectedPage" element={<ProfileRedirect />} />,
      <Route key={2} path="/profile/:selectedPage/:selectedAction" element={<ProfileRedirect />} />
    ]
  );
}

export default ProfileRoutes;
